import React, { useRef, useCallback, useEffect } from 'react';

/*
    This hook returns a ref that should be added to an element.
    When anything outside of that element is clicked the function
    passed into this hook will be called.
*/

export function useNonFocusEvent(nonFocusEvent) {
    const containerRef = useRef();
    useEffect(()=> {
        document.addEventListener('mousedown', handleClick, false);
        return ()=>document.removeEventListener('mousedown', handleClick, false);
    }, []);

    const handleClick = useCallback(({ target }) => {
        if (!containerRef.current.contains(target)) {
            nonFocusEvent();
        }
    });

    return containerRef;
}
